
import { useTranslation } from 'react-i18next';

export default function Purpose() {
  const { t } = useTranslation('about');

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0D1B2A] mb-4 tracking-tight">
            {t('purpose.title')}
          </h2>
          <p className="text-xl text-[#394B59] max-w-3xl mx-auto leading-relaxed">
            {t('purpose.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-[#F5F7FA] rounded-2xl p-8">
            <div className="w-16 h-16 bg-[#2E8BC0] rounded-xl flex items-center justify-center mb-6">
              <i className="ri-flag-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#0D1B2A] mb-4">
              {t('purpose.mission')}
            </h3>
            <p className="text-[#394B59] leading-relaxed">
              {t('purpose.missionText')}
            </p>
          </div>

          <div className="bg-[#F5F7FA] rounded-2xl p-8">
            <div className="w-16 h-16 bg-[#2E8BC0] rounded-xl flex items-center justify-center mb-6">
              <i className="ri-eye-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#0D1B2A] mb-4">
              {t('purpose.vision')}
            </h3>
            <p className="text-[#394B59] leading-relaxed">
              {t('purpose.visionText')}
            </p>
          </div>

          <div className="bg-[#F5F7FA] rounded-2xl p-8">
            <div className="w-16 h-16 bg-[#2E8BC0] rounded-xl flex items-center justify-center mb-6">
              <i className="ri-heart-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#0D1B2A] mb-4">
              {t('purpose.values')}
            </h3>
            <p className="text-[#394B59] leading-relaxed">
              {t('purpose.valuesText')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
